module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-500.e5eb45467d0f3265c79e.eot";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-500.eot
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-500.eot
// module chunks = styles